export const RecFormConfig = [
	{ name: 'name', placeholder: 'Name' },
	{ name: 'company_name', placeholder: 'Company Name' },
	{ name: 'company_type', placeholder: 'Company Type' },
	{ name: 'email', placeholder: 'Email Address', type: 'email' },
	{ name: 'contact', placeholder: 'Contact Number' },
];
